import { render, staticRenderFns } from "./cadastrar.vue?vue&type=template&id=6856f73c&"
import script from "./cadastrar.vue?vue&type=script&lang=js&"
export * from "./cadastrar.vue?vue&type=script&lang=js&"
import style0 from "./cadastrar.vue?vue&type=style&index=0&id=6856f73c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports